import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/tailwind.css'
import 'font-awesome/css/font-awesome.min.css' // 新增引入
import router from './router'  // 新增引入
import store from './store'    // 新增引入
import plugins from './plugins'

Vue.use(ElementUI)
Vue.use(plugins)
Vue.config.productionTip = false

new Vue({
  router,  // 注入路由
  store,   // 注入状态管理
  render: h => h(App),
}).$mount('#app')
